'use client'

import { useEffect } from 'react'
import Image from 'next/image'
import Link from 'next/link'
import logoGray from '../public/images/hive-logo-gray.png'

/**
 * Check if error is recoverable by a full page reload.
 * These errors typically occur when the server has been rebuilt
 * and the client has stale cached chunks or RSC data.
 */
function isStaleClientError(error) {
    const message = error?.message || ''
    const name = error?.name || ''

    return (
        message.includes('Connection closed') ||
        message.includes('Failed to fetch') ||
        message.includes('Load failed') ||
        name === 'ChunkLoadError' ||
        message.includes('ChunkLoadError') ||
        message.includes('Loading chunk') ||
        message.includes('NEXT_STATIC_GEN_BAILOUT')
    )
}

export default function Error({ error, reset }) {
    useEffect(() => {
        console.error('[Error Boundary]', error)

        // Auto-reload for stale client errors
        if (isStaleClientError(error)) {
            console.log('[Error Boundary] Stale client detected, reloading page...')
            window.location.reload()
        }
    }, [error])

    // If we get here, it's not a stale client error - show UI
    return (
        <div className="flex flex-col items-center justify-center min-h-[50vh] p-8 text-center">
            <Link href="/" className="mb-8">
                <Image
                    src={logoGray}
                    alt="hive modern"
                    width={120}
                    height={60}
                    priority
                />
            </Link>
            <h1 className="text-3xl font-light mb-3">We hit a snag</h1>
            <p className="text-gray-600 mb-8 max-w-md">
                Something unexpected happened. Please try again, or return to our homepage to continue shopping.
            </p>
            <div className="flex gap-4">
                <button
                    onClick={() => reset()}
                    className="btn btn-dark"
                >
                    Try again
                </button>
                <Link href="/" className="btn btn-outline">
                    Go to homepage
                </Link>
            </div>
        </div>
    )
}